import axios from 'axios';
import { API_BASE_URL as BASE_URL } from '../../config/api';

const API_BASE_URL = `${BASE_URL}/api/v1/blocks`;

export const getBlockList = async () => {
  const response = await axios.get(`${API_BASE_URL}`);
  return response.data; // { blockDtoList: [...] }
};

export const block = async (blockedId) => {
  const response = await axios.post(`${API_BASE_URL}`, {
    blockedId,
  });
  return response.data;
};

export const unblock = async (blockedId) => {
  const response = await axios.delete(`${API_BASE_URL}`, {
    data: { blockedId },
  });
  return response.data;
};